module.exports = __webpack_public_path__ + "static/media/foto2.7fcda509.png";